/** Settings tab ids — must match TabsTrigger value in Settings.js */

export const SETTINGS_TABS = {
  SAP_LANDSCAPE: "sap-landscape",
  GENERAL: "general",
  AGENTS: "agents",
  INTEGRATIONS: "integrations",
  NOTIFICATIONS: "notifications",
  SECURITY: "security",
  PERFORMANCE: "performance",
  USER_MANAGEMENT: "user-management",
};

/** Tabs visible only when Cognito group includes `admin`. */
export const ADMIN_ONLY_SETTINGS_TABS = new Set([
  SETTINGS_TABS.SAP_LANDSCAPE,
  SETTINGS_TABS.AGENTS,
  SETTINGS_TABS.INTEGRATIONS,
  SETTINGS_TABS.SECURITY,
  SETTINGS_TABS.PERFORMANCE,
  SETTINGS_TABS.USER_MANAGEMENT,
]);

/**
 * @param {string} tab
 * @param {boolean} isAdmin
 * @returns {string}
 */
export function coerceSettingsTab(tab, isAdmin) {
  if (!isAdmin && ADMIN_ONLY_SETTINGS_TABS.has(tab)) {
    return SETTINGS_TABS.GENERAL;
  }
  return tab;
}

/**
 * @param {boolean} isAdmin
 * @returns {string}
 */
export function defaultSettingsTab(isAdmin) {
  return isAdmin ? SETTINGS_TABS.SAP_LANDSCAPE : SETTINGS_TABS.GENERAL;
}
